import { useParams } from 'react-router-dom';

import { Modality } from 'src/types/api/data/image';
import cookieHelper from 'src/utils/cookieHelper';

/**
 * Hook to get modality value with fallback strategy:
 * 1. First try to read from URL params (backward compatibility)
 * 2. Fall back to reading from LUNIT_CTL_OFFICE_MODALITY cookie
 * 3. Throw error if neither source has a value
 */
function useModality(): Modality {
  const params = useParams<{ modalityLabel?: string }>();

  // First priority: URL parameter (for backward compatibility)
  if (params.modalityLabel) {
    return params.modalityLabel as Modality;
  }

  // Second priority: Cookie
  const modalityFromCookie = cookieHelper.getModality();
  if (modalityFromCookie) {
    return modalityFromCookie.toUpperCase() as Modality;
  }

  // No modality found - throw error
  throw new Error('Modality not found in URL params or cookie');
}

export default useModality;
